
import React from "react";

export { Status, PLAY, LOADING, STOP, LARGE, SMALL, Size, MessageLocation } from './PlayerReducerSetting'
import { Status, PLAY, LOADING, STOP, LARGE, SMALL, Size } from './PlayerReducerSetting'
import {getCookie} from "./utils";





export interface Stream {
    id: string
    isDefault: boolean,
    reklama?: {
        url: string,
        type: string
    },
    stationId: number,
    type: string,
    stationUrl: string
    logo?: string
    svgLogo?: string
    name: string
    obsah: string
    playlist: string
    url: string
}


export interface Streams {
    [path: string]: Stream
}

export interface Station {
    stationId: number,
    image: string,
    name: string,
    playlist: string,
    stationUrl: string,
    reklama?: {
        url: string,
        type: string
    }
};


export const NOADV_ACTION = 'NOADVACTION';

export interface NoAdvAction {
    type: typeof NOADV_ACTION
}

export const STREAMS_ACTION = 'STREAMSACTION'

export interface StreamsAction {
    type: typeof STREAMS_ACTION,
    payload: { streams: Streams, stations: Station[] }
}


export const INIT_ACTION = 'INITACTION'


export interface InitAction {
    type: typeof INIT_ACTION,

}

export const STATION_ACTION = 'STATIONACTION'

export interface StationAction {
    type: typeof STATION_ACTION,
    payload: Station | null
}

export const STATUS_ACTION = 'STATUSACTION'

export interface StatusAction {
    type: typeof STATUS_ACTION,
    payload: Status
}

export const VOLUME_ACTION = 'VOLUMEACTION';

export interface VolumeAction {
    type: typeof VOLUME_ACTION,
    payload: number
}

export const STYLESLOADED_ACTION = 'STYLESLOADEDACTION';

export interface StylesLoadedAction {
    type: typeof STYLESLOADED_ACTION
}

export const SIZE_ACTION = 'SIZEACTION';

export interface SizeAction {
    type: typeof SIZE_ACTION,
    payload: Size
}

export const POSITION_ACTION = 'POSITIONACTION';

export interface PositionAction {
    type: typeof POSITION_ACTION,
    payload: number
}

export const DOMAIN_ACTION = 'DOMAINACTION';

export interface DomainAction {
    type: typeof DOMAIN_ACTION,
    payload: string
}

export const AUDIOREFRESH_ACTION = "AUDIOREFRESHACTION";

export interface AudioRefreshAction {
    type: typeof AUDIOREFRESH_ACTION
}

export const ELEMENT_ACTION = 'ELEMENTACTION';

export interface ElementAction {
    type: typeof ELEMENT_ACTION,
    payload: HTMLElement
}

export type Actions =
    StatusAction
    | StationAction
    | StreamsAction
    | VolumeAction
    | SizeAction
    | PositionAction
    | InitAction
    | StylesLoadedAction
    | DomainAction
    | NoAdvAction
    | AudioRefreshAction
    | ElementAction;

export const getStations = (stationsPayload: Streams) => {

    const streamsData = JSON.parse(JSON.stringify(stationsPayload)) as Streams;

    const stations: Station[] = [];
    const urlreklama = streamsData['reklama'] as any as string || '';
    for (const key in streamsData) {
        if (key === 'reklama')
            continue;
        const {
            svgLogo,
            logo,
            name,
            stationId,
            playlist,
            isDefault,
            stationUrl
        } = streamsData[key];

        if (!(svgLogo || logo) || !isDefault) {
            delete streamsData[key];
        } else {
            const reklama = urlreklama ? { url: urlreklama, type: 'vast'} : undefined
            stations.push({
                stationId,
                image: svgLogo || logo || '',
                name,
                playlist,
                stationUrl,
                reklama
            });
        }
    }

    return {
        streams: streamsData,
        stations: stations
    }
}

const stationReducer = (station: Station | null | undefined = null, action: Actions): Station | null => {
    switch (action.type) {
        case STREAMS_ACTION:
            const idStat = parseInt(getCookie('puuidstat')+'');

            return action.payload.stations.filter(item=>{
                return item.stationId == idStat;
            })[0] || action.payload.stations[0] || null

        case STATION_ACTION:
            return action.payload;
    }
    return station;
}

const advReducer = (adv: boolean = true, action: Actions): boolean => {
    switch (action.type )
    {
        case NOADV_ACTION:
            return false;
    }

    return adv;
}

const stationsReducer = (stations: Station[] = [], action: Actions): Station[] => {
    switch (action.type) {
        case STREAMS_ACTION:
            return action.payload.stations;
    }

    return stations;
}

const streamsReducer = (streams: Streams = {}, action: Actions) => {
    switch (action.type) {
        case STREAMS_ACTION:
            return action.payload.streams;
    }
    return streams;
}

const widthReducer = (width: number = 300, action: Actions) => {
    return width;
}

const heightReducer = (height: number = 300, action:Actions) =>{
    switch (action.type){
        case SIZE_ACTION:
            if (action.payload === LARGE)
                return 300;
            return 170;

    }
    return height;
}

const statusReducer = (status: Status = 'STOP', action: Actions): Status => {


    switch (action.type) {
        case STATUS_ACTION:
            return action.payload as Status;
        case STATION_ACTION:
            if (action.payload)
                return 'LOADING';
            return 'STOP';
    }
    return status;
}

const volumeReducer = (volume: number = 1, action: Actions): number => {
    switch (action.type) {
        case VOLUME_ACTION:

            volume = action.payload;

            if (volume > 1)
                volume = 1;
            if (volume < 0)
                volume = 0;

            return volume;
    }
    return volume;
}

const sizeReducer = (size: Size = LARGE, action: Actions): Size => {
    switch (action.type) {
        case SIZE_ACTION:
            return action.payload;
    }

    return size;
}

const pingReducer = (ping: boolean = false, action: Actions): boolean => {

    switch (action.type) {
        case STATUS_ACTION:
            if (action.payload === 'STOP')
                return false;
            break;
        case STATION_ACTION:
            return false;
    }
    return ping;
}
const stylesLoadedReducer = (is: boolean = false, action: Actions): boolean => {
    switch (action.type)
    {
        case STYLESLOADED_ACTION:
            return true;
    }
    return false;
}

const positionReducer = (position: number = 0, action: Actions): number => {
    switch (action.type) {
        case POSITION_ACTION:
            return action.payload;

    }
    return position;
}

const domainReducer = (domain: string = 'prehravac', action:Actions): string => {
    switch (action.type)
    {
        case DOMAIN_ACTION:
            return action.payload;
    }
    return domain;
}

const audioRefreshReducer = (payload: number = 0, action: Actions): number => {
    switch (action.type)
    {
        case AUDIOREFRESH_ACTION:
            return payload+1;
    }
    return payload;
}
const elementReduer = (payload: HTMLElement|null= null , action: Actions): HTMLElement|null => {
    if (action.type === ELEMENT_ACTION)
    {
        return action.payload;
    }
    return payload;
}



export type Player = {
    streams: Streams
    station: Station | null
    stations: Station[]
    status: Status
    volume: number
    size: Size
    position: number
    width: number
    height: number
    styleLoaded: boolean
    domain: string
    adv: boolean
    element: HTMLElement|null
    audioRefresh: number
}

const Reducers = {
    status: statusReducer,
    streams: streamsReducer,
    stations: stationsReducer,
    station: stationReducer,
    volume: volumeReducer,
    size: sizeReducer,
    position: positionReducer,
    width: widthReducer,
    height: heightReducer,
    styleLoaded: stylesLoadedReducer,
    domain: domainReducer,
    adv: advReducer,
    audioRefresh: audioRefreshReducer,
    element: elementReduer
}




export const PlayerInitContext = () =>{
    return ()=> {

        const state = {};

        for (let i in Reducers) {
            state[i] = Reducers[i](state[i], {type: INIT_ACTION});
        }
        return state as Player;
    }
}
export const PlayerReducerContext = (state:Player, action: Actions):Player=>{

    const newState = {};
    let changes = false;
    for (let i in Reducers) {
        newState[i] = Reducers[i](state[i], action);
        changes = changes || newState[i] !== state[i];
    }
    if (changes)
        return {...state, ...newState} as Player;
    else
        return state;
}

export const PlayerContext = React.createContext<Player>(PlayerInitContext()());


export const PlayerContextDispatch = React.createContext<React.Dispatch<Actions>>((value: Actions)=> {});

export type PlayerAndDispatch = Player & { dispatch: React.Dispatch<Actions> }
